import { motion } from 'framer-motion';

const AnimatedText = ({ text, className = "", ...props }) => {
  return (
    <span className={className} {...props}>
      {text.split("").map((char, index) => (
        <motion.span
          key={index}
          className="inline-block"
          initial={{ scale: 1, opacity: .8 }}
          whileInView={{ 
            scale: [1, 1.21, 1.1],
            opacity: 1,
            transition: {
              delay: index * 0.05,
              duration: 0.8,
              ease: [0.25, 0.46, 0.45, 0.94]
            }
          }}
          viewport={{ once: true, margin: "-50px" }}
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </span>
  );
};

export default AnimatedText;